// extracted by mini-css-extract-plugin
export default {"h2_heading":"Form_h2_heading__qEkc1"};